import { gql } from "@apollo/client"

/**
 * Arbre d'un référentiel le long d'une relation parent ↔ enfant. Partagée par le filtre
 * (`HierarchicalFilter`) et son écran de réglage (`ConfigHierarchyValues`), qui doivent lire le
 * même arbre — mêmes variables, donc même entrée du cache Apollo.
 */
export const GET_REFERENTIAL_HIERARCHY = gql`
  query GetReferentialHierarchy(
    $referentialId: String!
    $relationId: String!
    $parentSide: String
    $labelColumnId: String
  ) {
    getReferentialHierarchy(
      referentialId: $referentialId
      relationId: $relationId
      parentSide: $parentSide
      labelColumnId: $labelColumnId
    ) {
      id
      label
      parentId
    }
  }
`
